import { render, staticRenderFns } from "./TagAdd.vue?vue&type=template&id=0977a79a&scoped=true"
import script from "./TagAdd.vue?vue&type=script&lang=js"
export * from "./TagAdd.vue?vue&type=script&lang=js"
import style0 from "./TagAdd.vue?vue&type=style&index=0&id=0977a79a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0977a79a",
  null
  
)

export default component.exports